export default __webpack_public_path__ + "static/103-9a35a648a79a63ca619d48e86113f1b4.jpg";